import { Duplex } from 'stream'
import { UserError } from './userError'

class CustomDuplex extends Duplex {
  constructor (private writeAction: (data: Buffer) => void, private closeAction: () => void) {
    super()
  }

  override _read () {}

  override _write (chunk, encoding, callback) {
    try { this.writeAction(chunk); callback() } catch { callback(new UserError('WebSocket connection is not available')) }
  }

  override _final (callback) {
    this.closeAction()
    callback()
  }

  override _destroy (error, callback) {
    this.closeAction()
    callback(error)
  }
}

export const getWebsocketStream = async (host: string) => {
  const baseProtocol = host.startsWith('ws://') ? 'ws' : 'wss'
  const hostClean = host.replace('ws://', '').replace('wss://', '')
  const hostURL = new URL(`${baseProtocol}://${hostClean}`)
  const hostParams = hostURL.searchParams
  hostParams.append('client_mcraft', '')
  const ws = new WebSocket(`${baseProtocol}://${hostURL.host}${hostURL.pathname}?${hostParams.toString()}`)
  ws.binaryType = 'arraybuffer'
  const closeSocket = () => {
    if (ws.readyState === WebSocket.CONNECTING || ws.readyState === WebSocket.OPEN) ws.close()
  }
  const clientDuplex = new CustomDuplex(data => ws.send(data), closeSocket)

  clientDuplex.on('error', () => clientDuplex.destroy())

  ws.addEventListener('message', async message => {
    try {
      let { data } = message
      if (data instanceof Blob) data = await data.arrayBuffer()
      if (!clientDuplex.destroyed) clientDuplex.push(Buffer.from(data))
    } catch {
      clientDuplex.destroy(new UserError('Invalid WebSocket message'))
    }
  })

  ws.addEventListener('close', () => {
    clientDuplex.push(null)
    clientDuplex.destroy()
  })

  ws.addEventListener('error', () => {
    clientDuplex.destroy(new UserError('WebSocket connection failed'))
  })

  await new Promise<void>((resolve, reject) => {
    let settled = false
    const finish = (error?: Error) => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      ws.removeEventListener('open', opened)
      ws.removeEventListener('error', failed)
      ws.removeEventListener('close', closed)
      if (error) { clientDuplex.destroy(); reject(error) } else resolve()
    }
    const opened = () => finish()
    const failed = () => finish(new UserError('Failed to open WebSocket connection'))
    const closed = () => finish(new UserError('WebSocket closed before connecting'))
    const timer = setTimeout(() => finish(new UserError('WebSocket connection timed out')), 15000)
    ws.addEventListener('open', opened)
    ws.addEventListener('error', failed)
    ws.addEventListener('close', closed)
  })

  return {
    mineflayerStream: clientDuplex,
    ws,
  }
}
